// apiUrls.js
export const stageUrl = 'https://otc-api.muda.exchange';
export const webUrl = 'https://web-api.stage-mudax.xyz/api';
export const exchangeUrl = 'https://ws.muda.exchange/api/wallet';
